import { cn } from '@simplywallst/ui-core/next';

type Value = 'BUY' | 'SELL';

type Props = {
  value: Value;
  onChange: (value: Value) => void;
};

const commonClasses =
  'relative flex w-full h-10 text-softer text-xs font-strong justify-center items-center rounded-x0_5 hover:text-solid hover:bg-surface-3 focus-visible:ring-2 focus-visible:duration-0 focus-visible:ring-accent focus-visible:ring-inset';

export const TypeField = ({ value, onChange }: Props) => {
  const classes = {
    buy: cn(
      commonClasses,
      value === 'BUY' &&
        'bg-p-green-100 text-solid aria-selected:bg-p-green-100'
    ),
    sell: cn(
      commonClasses,
      value === 'SELL' && 'bg-p-red-100 text-solid aria-selected:bg-p-red-100'
    ),
  };

  return (
    <div className="grid grid-cols-2 gap-1" role="tablist">
      <button
        className={classes.buy}
        role="tab"
        value="buy"
        aria-selected={value === 'BUY'}
        onClick={() => onChange('BUY')}
      >
        BUY
      </button>
      <button
        className={classes.sell}
        role="tab"
        value="sell"
        aria-selected={value === 'SELL'}
        onClick={() => onChange('SELL')}
      >
        SELL
      </button>
    </div>
  );
};
